import React, {useState} from 'react';
import Header from './components/Header';
import TimerView from './components/TimerView';
import SettingsView from './components/SettingsView';
import OfflineBanner from './components/OfflineBanner';
import {AppView} from "./types/components";
import {AppContextProvider, useAppContext} from './context/AppContext';
import DownloadsView from "./components/DownloadsView";
import FloatingTimer from "./components/FloatingTimer";
import SignIn from './components/SignIn';

const App: React.FC = () => {
  // TODO: reset view on sign out
  const [currentView, setCurrentView] = useState<AppView>('timer');

  const renderView = () => {
    switch (currentView) {
      case 'settings':
        return <SettingsView/>;
      case 'downloads':
        return <DownloadsView/>;
      case 'timer':
      default:
        return <TimerView/>;
    }
  };

  const AppShell: React.FC = () => {
    const {isConnected, isCheckingConnection} = useAppContext();

    if (isCheckingConnection) {
      return (
        <div className="app-splash">
          <p>Checking connection…</p>
        </div>
      );
    }

    if (!isConnected) {
      return <SignIn/>;
    }

    return (
      <>
        <OfflineBanner/>
        <Header
          currentView={currentView}
          onViewChange={setCurrentView}
        />
        <main className="app-main">
          {renderView()}
        </main>
        <FloatingTimer/>
      </>
    );
  };

  return (
    <AppContextProvider>
      <AppShell/>
    </AppContextProvider>
  );
};

export default App;